module.exports = __webpack_public_path__ + "img/Facebook.0237348d.svg";